class ObjCommon  {
  id = '';

  constructor(id) {
    id = typeof(id) !== 'undefined' ? id : '';
    this.id = id;
  } 

  obSet(ob) {
    for (const key in ob) {
      if (ob.hasOwnProperty(key)) {
        if (this.hasOwnProperty(key)) {
          this[key] = ob[key];
          
        }
        
      }
    }
  }

}

export default ObjCommon;
